var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    [
      _vm.externalLink
        ? _c(
            "a",
            { class: _vm.appendClass, attrs: { href: _vm.goTo } },
            [_vm._t("default")],
            2
          )
        : _c(
            "router-link",
            { class: _vm.appendClass, attrs: { to: _vm.goTo } },
            [_vm._t("default")],
            2
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }